/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      color: 'gamma.500',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',

      '&&': {
        border: '2px solid',
        borderRadius: 'md',
        borderColor: 'gamma.400',
        bg: 'alpha.700',
      },

      '&::placeholder': {
        color: 'gamma.600',
      },

      _hover: {
        '&&': {
          border: '2px solid',
          borderColor: 'gamma.400',
          bg: 'alpha.700',
        },
      },

      _focus: {
        '&&': {
          border: '2px solid',
          borderColor: 'gamma.400',
          bg: 'alpha.900',
          boxShadow:
            '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'black',
      fontSize: 'sm',
      color: 'gamma.800',
      '&&': {
        bgGradient: 'linear(to-b, gamma.300, gamma.400)',
        border: 'none',
        boxShadow: '0px 2px 3px 1px rgba(0, 0, 0, 0.1)',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          boxShadow: 'none',
          '&&': {
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {},
};
